import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { GetStockLevelsInput, PaginationInput } from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';

import stockLocationKeys from './keyFactory';

const GetStockLocationStockLevels = graphql(`
  query StockLocationStockLevels(
    $id: ID!
    $input: GetStockLevelsInput
    $pagination: PaginationInput!
  ) {
    stockLocation(id: $id) {
      id
      materialsList {
        id
        stockLevels(input: $input, pagination: $pagination) {
          items {
            id
            onHandQuantity
            material {
              id
              name
            }
            weightedAverageCostExcTax {
              valueInMinor
              currency {
                id
                code
                exponent
              }
            }
            totalValueExcTax {
              valueInMinor
              currency {
                id
                code
                exponent
              }
            }
          }
          totalCount
          offset
          limit
        }
      }
    }
  }
`);

const useGetStockLocationStockLevels = (
  id: string | undefined,
  input: GetStockLevelsInput = {},
  pagination: PaginationInput = PAGINATION_ARG_DEFAULTS
) => {
  const { data, ...rest } = useQuery({
    queryKey: stockLocationKeys.stockLevels(id ?? '', input, pagination),
    queryFn: () =>
      gqlClient.request(GetStockLocationStockLevels, {
        id: id!,
        input,
        pagination,
      }),
    enabled: !!id,
  });

  return {
    stockLevels: data?.stockLocation?.materialsList?.stockLevels,
    ...rest,
  };
};

export default useGetStockLocationStockLevels;
